<header [class.scrolled]="scrolled">
	<div class="wrapper flex-center">
		<img (click)="routerService.open('')" class="logo" alt="Logo Arkas" src="assets/img/logo-white.svg" />
		<div class="menu-container"><app-menu></app-menu></div>
	</div>
</header>
